export const APP_INIT_SAGA = "APP_INIT_SAGA";
export const APP_SYSTEM_INFO_SAGA = "APP_SYSTEM_INFO_SAGA";
export const APP_SET_SYSTEM_INFO = "APP_SET_SYSTEM_INFO";
export const APP_INITIALIZED = "APP_INITIALIZED";
export const APP_LOCALE_STORAGE_KEY = "locale";
export const APP_APPCODE_STORAGE_KEY = "appcode";
export const APP_LOCALE_EN = "en";
export const APP_LOCALE_DE = "de";
export const APP_LOCALE_AVAILABLE_LOCALES = [APP_LOCALE_DE, APP_LOCALE_EN];
export const APP_LOCALE_FALLBACK = APP_LOCALE_DE;
export const APP_LOCALE_CHANGE_SAGA = "APP_LOCALE_CHANGE_SAGA";
export const APP_APPCODE_CHANGE_SAGA = "APP_APPCODE_CHANGE_SAGA";

export const OPEN_SIDEBAR = "@APP/OPEN_SIDEBAR";
export const CLOSE_SIDEBAR = "@APP/CLOSE_SIDEBAR";
export const TOGGLE_SIDEBAR = "@APP/TOGGLE_SIDEBAR";
export const RESIZE_WINDOW = "@APP/RESIZE_WINDOW";
export const GET_APP_DATA_SAGA = "GET_APP_DATA_SAGA";
export const GET_APP_DATA_SUCCESS = "@APP/GET_APP_DATA_SUCCESS";

export const APP_API_URL_SAGA = "APP_API_URL_SAGA";
export const APP_SET_API_URL_INFO = "APP_SET_API_URL_INFO";

export const APP_UPDATE_PARAMETER_SAGA = "APP_UPDATE_PARAMETER_SAGA";
export const APP_UPDATE_COLOR_SAGA = "APP_UPDATE_COLOR_SAGA";

export const APP_UPDATE_PARAMAETER = "APP_UPDATE_PARAMETER";

export const APP_SET_AUTHCODE_INFO = "APP_SET_AUTHCODE_INFO";

export const SERVER_VERSION_DOES_NO_MATCH = "SERVER_VERSION_DOES_NO_MATCH"

export const GET_APP_MODULE_SAGA = "GET_APP_MODULE_SAGA"
export const APP_SET_MODULE_INFO = "APP_SET_MODULE_INFO"
